import { useEffect, useState } from "react";
/**
 * A custom hook to check if the page was restored from the back-forward-cache.
 *
 * Useful to cleanup any restored states when page is restored from the bfcache.
 *
 * [MDN Web Docs - bfcache](https://developer.mozilla.org/en-US/docs/Glossary/bfcache)
 */
export const useCheckBFCache = () => {
    const [isPageFromCache, setIsPageFromCache] = useState(false);
    function handleTransitionEvent(event) {
        setIsPageFromCache(Boolean(event.persisted));
    }
    useEffect(() => {
        window.addEventListener("pageshow", handleTransitionEvent);
        return () => {
            window.removeEventListener("pageshow", handleTransitionEvent);
        };
    }, []);
    return { isPageFromCache };
};
//# sourceMappingURL=useCheckBFCache.js.map